import React from 'react';

import { ToggleCard } from '@weezevent/nacre';
import Editor from './Editor';

const BrandKitBody = ({ formKey, title, subtitle, form, setForm, onClose, organizationId, selectedLanguage }) => {
    return (
        <ToggleCard subtitle={subtitle} title={title} toggle={!!form[formKey].length} onToggle={value => onClose(formKey, value, [])}>
            <Editor bodies={form[formKey]} selectedLanguage={selectedLanguage} organizationId={organizationId} handleChange={bodies => setForm(formKey, bodies)} />
        </ToggleCard>
    );
};

export default BrandKitBody;
